export default __webpack_public_path__ + "static/media/classified.d911e492.JPG";